module.exports = __webpack_public_path__ + "img/icon_apple_pay.fe4f01ad.svg";